import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";
import { INCENTIVE_FILTER_STORE_CONFIG_BY_FIELD_MAP } from "@/other/constants/IncentiveKeys.jsx";

export class OutcomeIncentiveCondition extends HasProjectMixin(Model) {
  static get $name() {
    return "OutcomeIncentiveCondition";
  }

  static get fields() {
    return [
      { name: "entityType", dataSource: "entity_type" },
      { name: "field", dataSource: "field" },
      { name: "operator", dataSource: "operator" },
      { name: "value", dataSource: "value" },
      { name: "incentiveId", dataSource: "outcome_incentive" },
      { name: "order", dataSource: "order" },
      { name: "booleanOperator", dataSource: "boolean_operator" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
    ];
  }

  get valueRecord() {
    const { storeKey, recordKey } = INCENTIVE_FILTER_STORE_CONFIG_BY_FIELD_MAP[this.entityType][this.field];
    const store = this.project?.getCrudStore?.(storeKey);
    return store?.find((record) => record[recordKey] === this.value, true);
  }

}